// src/cpq_agent/webchat_ui/chat-edit-helpers.js
//
// Pure, dependency-FREE helpers for the chat regenerate / edit-and-resend flows.
// Kept import-free on purpose so they stay unit-testable in plain node
// (chat-edit-helpers.test.mjs) without pulling the DOM render chain — same
// rationale as agent-finalize-helpers.js.

/**
 * Return a copy of `messages` keeping only indices 0..keepIndex (inclusive),
 * i.e. drop every message AFTER keepIndex. Used by the regenerate and
 * edit-and-resend flows to truncate the transcript before re-running a turn.
 *
 * keepIndex < 0 truncates to empty; a keepIndex past the end keeps everything.
 * NEVER mutates the input array.
 *
 * @param {Array} messages
 * @param {number} keepIndex — the last index to KEEP
 * @returns {Array} a new array
 */
export function truncateMessagesAfter(messages, keepIndex) {
  if (!Array.isArray(messages)) return [];
  if (keepIndex < 0) return [];
  return messages.slice(0, keepIndex + 1);
}

/**
 * Index of the last message with role "user" at or before `fromIndex`
 * (default: the end of the array). Returns -1 when there is none.
 * Used by regenerate to find the prompt that produced the last answer.
 *
 * @param {Array} messages
 * @param {number} [fromIndex]
 * @returns {number}
 */
export function lastUserIndex(messages, fromIndex) {
  if (!Array.isArray(messages)) return -1;
  let start = typeof fromIndex === "number" ? fromIndex : messages.length - 1;
  if (start > messages.length - 1) start = messages.length - 1;
  for (let i = start; i >= 0; i--) {
    if (messages[i] && messages[i].role === "user") return i;
  }
  return -1;
}
